import { Clipboard } from './Clipboard';

export { Clipboard };
